import React from 'react'

const Spinner = () => {
    return (
        <div className="loader">loading...</div>
    )
}

export default Spinner